export const EntityName = {
	BASKET: 'basket',
	CATEGORY: 'category',
	LOCALE: 'locale',
	MERCHANT: 'merchant',
	PRODUCT: 'product',
	STORE: 'store',
	TEMPLATE: 'template',
	TEMPLATE_CONFIGURATION: 'template-configuration',
} as const;
